import { Center, Loader, useMantineTheme } from '@mantine/core'
import React from 'react'

import RenderReplaceWrapper from '../RenderReplaceWrapper'

const LoaderReplace = (): React.ReactElement => {
  const theme = useMantineTheme()
  return (
    <RenderReplaceWrapper backgroundColor={theme.white}>
      <Center style={{ height: '90vh', flexDirection: 'column' }}>
        <Loader variant="dots" />
      </Center>
    </RenderReplaceWrapper>
  )
}

export default LoaderReplace
